import React from 'react'
import { Handle, Position, NodeProps } from 'reactflow'

const StartNode: React.FC<NodeProps> = ({ selected }) => {
  return (
    <div 
      className={`node-base w-16 h-16 text-white rounded-full ${selected ? 'ring-2 ring-blue-400' : ''}`}
      style={{
        backgroundColor: 'var(--color-primary)',
        borderColor: 'var(--color-primary)'
      }}
    >
      <div className="flex items-center justify-center h-full">
        <img 
          src="/icons/start-button.png" 
          alt="Start" 
          className="h-8 object-contain"
          style={{
            filter: 'brightness(0) invert(1)',
            imageRendering: 'crisp-edges',
            maxWidth: '48px'
          }}
        />
      </div>
      
      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-white border-2 border-blue-900 dark:border-blue-600"
      />
    </div>
  )
}

export default StartNode
